module.exports = __webpack_public_path__ + "img/104069.bcbb1dfd.png";